import { beaconAssert } from "./assertions.js";
export const TextUtils = {
    parseIntOrFail(value) {
        beaconAssert(/^\s*-?\d+\s*$/.test(value), `Could not parse '${value}' as an integer`);
        const parsed = parseInt(value.trim());
        beaconAssert(!isNaN(parsed), `Could not parse '${value}' as an integer`);
        return parsed;
    },
    parseFloatOrFail(value) {
        beaconAssert(/^\s*-?\d+(\.\d+)?\s*$/.test(value), `Could not parse '${value}' as a float`);
        const parsed = parseFloat(value.trim());
        beaconAssert(!isNaN(parsed), `Could not parse '${value}' as a float`);
        return parsed;
    },
};
//# sourceMappingURL=text-utils.js.map